import crmService from "@/services/crm/models/crmService";
import crmServicePermission from "@/services/crm/models/crmServicePermission";
import crmServicePermissionToInternalRole from "@/services/crm/models/crmServicePermissionToInternalRole";
import internalCompany from "@/services/sso/models/internalCompany";
import internalDepartment from "@/services/sso/models/internalDepartment";
import internalRole from "@/services/sso/models/internalRole";
import internalUser from "@/services/sso/models/internalUser";
import internalRoleToInternalUser from "@/services/sso/models/internalRoleToInternalUser";
import ssoBusiness from "@/services/sso/models/ssoBusiness";
import ssoMicrosoftAccount from "@/services/sso/models/ssoMicrosoftAccount";
import ssoTeam from "@/services/sso/models/ssoTeam";
import ssoTeamToInternalUser from "@/services/sso/models/ssoTeamToInternalUser";
import ssoWebhook from "@/services/sso/models/ssoWebhook";
import hrdcApplication from "@/services/hrdc/models/application";
import hrdcEmailClient from "@/services/hrdc/models/emailClient";
import hrdcRevertForm from "@/services/hrdc/models/revertForm";
import hrdcManualInvoice from "@/services/hrdc/models/manualInvoice";
import hrdcClaimSubmit from "@/services/hrdc/models/claimSubmit";
import hrdcClaimApproved from "@/services/hrdc/models/claimApproved";
import hrdcPaymentReceived from "@/services/hrdc/models/paymentReceived";
import hrdcCreditNoteGenerate from "@/services/hrdc/models/creditNoteGenerate";
import hrdcCreditNoteRequested from "@/services/hrdc/models/creditNoteRequested";
import hrdcCreditNoteDocumented from "@/services/hrdc/models/creditNoteDocumented";
import hrdcRefundEmailSubmission from "@/services/hrdc/models/refundEmailSubmission";
import hrdcRefundEmailApproval1 from "@/services/hrdc/models/refundEmailApproval1";
import hrdcRefundEmailApproval2 from "@/services/hrdc/models/refundEmailApproval2";
import hrdcRefundEmailArToAp from "@/services/hrdc/models/refundEmailArToAp";
import hrdcRefundEmailApToCimb from "@/services/hrdc/models/refundApToCimb";
import hrdcRefundFailed from "@/services/hrdc/models/refundFailed";
import hrdcFinanceRefundToClient from "@/services/hrdc/models/financeRefundToClient";
import hrdcEmailPaymentAdviceToClient from "@/services/hrdc/models/emailPaymentAdviceToClient";
import hrdcEnrollmentDetail from "@/services/hrdc/models/enrollmentDetail";
import hrdcGrantNoSubmit from "@/services/hrdc/models/grantNoSubmit";
import hrdcApplicationSubmissionDate from "@/services/hrdc/models/submissionDate";
import HrdcReportAnalysis from "@/services/hrdc/models/reportAnalysis";
import hrdcGeneralInfo from "@/services/hrdc/models/generalInfo";
import HrdcSettingsPrice from "@/services/hrdc/models/price";
import HrdcSettingsErrorLog from "@/services/hrdc/models/errorLog";
import HrdcSettingsJob from "@/services/hrdc/models/job";
import HrdcSettingsXero from "@/services/hrdc/models/xero";
import HrdcSettingsAttachment from "@/services/hrdc/models/attachment";
import HrdcSettingsSurvey from "@/services/hrdc/models/survey";
import HrdcSettingsCompany from "@/services/hrdc/models/company";

const models = {
  crmService,
  crmServicePermission,
  crmServicePermissionToInternalRole,
  internalCompany,
  internalDepartment,
  internalRole,
  internalUser,
  internalRoleToInternalUser,
  ssoBusiness,
  ssoMicrosoftAccount,
  ssoTeam,
  ssoTeamToInternalUser,
  ssoWebhook,
  hrdcApplication,
  hrdcEmailClient,
  hrdcRevertForm,
  hrdcManualInvoice,
  hrdcClaimSubmit,
  hrdcClaimApproved,
  hrdcPaymentReceived,
  hrdcCreditNoteGenerate,
  hrdcCreditNoteRequested,
  hrdcCreditNoteDocumented,
  hrdcRefundEmailSubmission,
  hrdcRefundEmailApproval1,
  hrdcRefundEmailApproval2,
  hrdcRefundEmailArToAp,
  hrdcRefundEmailApToCimb,
  hrdcRefundFailed,
  hrdcFinanceRefundToClient,
  hrdcEmailPaymentAdviceToClient,
  hrdcEnrollmentDetail,
  hrdcGrantNoSubmit,
  hrdcApplicationSubmissionDate,
  HrdcReportAnalysis,
  hrdcGeneralInfo,
  HrdcSettingsPrice,
  HrdcSettingsErrorLog,
  HrdcSettingsJob,
  HrdcSettingsXero,
  HrdcSettingsAttachment,
  HrdcSettingsSurvey,
  HrdcSettingsCompany,
};

export function registerModels(newModels) {
  Object.assign(models, newModels);
}

export default models;
